import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { SvgProps } from 'react-native-svg';
import { useUnistyles } from 'react-native-unistyles';

import type { AppColors } from '@squire/ui';

export interface ClockIconProps extends SvgProps {
  size?: number;
  color?: keyof AppColors;
  selected?: boolean;
}

export const ClockIcon: React.FC<ClockIconProps> = ({
  size = 24,
  color = 'iconPrimary',
  selected = false,
  ...props
}) => {
  const { theme: colors } = useUnistyles();
  const viewBox = selected ? '0 0 13 13' : '0 0 15 15';
  const path = selected
    ? 'M13 6.49689C13 10.0593 10.0641 13 6.5 13C2.93589 13 0 10.0593 0 6.49689C0 2.93448 2.93589 0 6.5 0C10.0579 0 13 2.93448 13 6.49689ZM3.45826 7.36731H6.49988C6.80467 7.36731 7.04725 7.12484 7.04725 6.81398V2.84746C7.04725 2.54282 6.80467 2.30035 6.49988 2.30035C6.18888 2.30035 5.9463 2.54282 5.9463 2.84746V6.26688H3.45826C3.14725 6.26688 2.91089 6.50935 2.91089 6.81398C2.91089 7.12484 3.14725 7.36731 3.45826 7.36731Z'
    : 'M7.3125 14.625C11.3221 14.625 14.625 11.3167 14.625 7.309C14.625 3.30129 11.3151 0 7.3125 0C3.30287 0 0 3.30129 0 7.309C0 11.3167 3.30287 14.625 7.3125 14.625ZM7.3125 12.9813C4.17057 12.9813 1.65144 10.4494 1.65144 7.309C1.65144 4.16858 4.16358 1.64365 7.3125 1.64365C10.4544 1.64365 12.9806 4.16858 12.9876 7.309C12.9876 10.4494 10.4544 12.9813 7.3125 12.9813ZM3.89067 8.2882H7.3125C7.65538 8.2882 7.92829 8.01542 7.92829 7.66571V3.20337C7.92829 2.86065 7.65538 2.58788 7.3125 2.58788C6.96262 2.58788 6.68971 2.86065 6.68971 3.20337V7.05022H3.89067C3.54079 7.05022 3.27488 7.32299 3.27488 7.66571C3.27488 8.01542 3.54079 8.2882 3.89067 8.2882Z';
  return (
    <Svg {...props} width={size} height={size} viewBox={viewBox} fill="none">
      {selected ? (
        <Path
          fillRule="evenodd"
          clipRule="evenodd"
          d={path}
          fill={colors[color]}
        />
      ) : (
        <Path d={path} fill={colors[color]} />
      )}
    </Svg>
  );
};

ClockIcon.displayName = 'ClockIcon';
